
import Vue from 'vue'

export default Vue.extend({
  name: 'footerComponent',
  data: () => ({
    baseUrl: window.location.host
  }),
  computed: {
    footerCompanyHref () {
      if (this.getServiceConfigProperty('companyAbrv') === 'Apex') return 'https://passport.apex-prop.company/'
      if (this.getServiceConfigProperty('companyAbrv') === 'LiSA') return 'https://passport.cryptolive.su/'
      return 'https://trade.whitelist.capital/'
    }
  }
})
